"use strict";

function initSolarLeadForm() {
	const solarLeadForm = '.js-solar-lead-form',
		triggerStepButton = '.js-trigger-step',
		nextStepButton = '.js-trigger-next-step',
		prevStepButton = '.js-trigger-prev-step',
		elementSolarLeadForm = document.querySelector(solarLeadForm);

	if (elementSolarLeadForm) {
		const elementSolarLeadFormButtons = elementSolarLeadForm.querySelectorAll(triggerStepButton),
			elementSolarLeadFormNextButton = elementSolarLeadForm.querySelector(nextStepButton),
			elementSolarLeadFormPrevButton = elementSolarLeadForm.querySelector(prevStepButton);
		if (elementSolarLeadFormButtons.length > 0) {
			elementSolarLeadFormButtons.forEach(elementSolarLeadFormButton => {
				elementSolarLeadFormButton.addEventListener('click', function (event) {
					document.getElementById("__currentPage").setAttribute("value", this.getAttribute("data-step-index"));
					document.forms[this.getAttribute("data-form-id")].submit();
				});
			})
		}
		if (elementSolarLeadFormNextButton) {
			elementSolarLeadFormNextButton.addEventListener('click', function (event) {
				const maxVisitedStep = sessionStorage.getItem("maxVisitedStep"),
					index = this.getAttribute("data-current-step-index");
				if (maxVisitedStep !== null && index >= maxVisitedStep) {
					sessionStorage.setItem("maxVisitedStep", +index + 1);
				}
				scrollSolarLeadFormIntoView();
			});
		}
		if (elementSolarLeadFormPrevButton) {
			elementSolarLeadFormPrevButton.addEventListener('click', function () {
				document.getElementById("__currentPage").setAttribute("value", index);
				document.forms[this.getAttribute("data-form-id")].submit();
			});
		}
	}
}

function scrollSolarLeadFormIntoView() {
	if (window.location.hash.substring(1).includes('solarLeadForm')) {
		document.querySelector('.js-solar-lead-form').scrollIntoView({
			behavior: 'instant',
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	initSolarLeadForm();
	scrollSolarLeadFormIntoView();
});

scrollSolarLeadFormIntoView();
